import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DashboardOverviewSection } from "./DashboardOverviewSection";
import { DashboardAccountsSection } from "./DashboardAccountsSection";
import { DashboardAgendaSection } from "./DashboardAgendaSection";
import type { MonthlyData, CategoryData, MonthlyComparison } from "@/hooks/use-dashboard-analytics";
import type { DragEndEvent } from "@dnd-kit/core";
import type { DueAlert } from "@/hooks/use-due-alerts";

interface DashboardMobileTabsProps {
  // Overview
  monthlyData: MonthlyData[];
  categoryData: CategoryData[];
  monthlyComparison: MonthlyComparison;
  analyticsLoading: boolean;
  // Accounts
  bankAccounts: any[];
  creditCards: any[];
  onAddAccount: () => void;
  onAddCreditCard?: () => void;
  onEditAccount: (account: any) => void;
  onAddTransaction: (accountId: string) => void;
  onViewInvoice: (accountId: string) => void;
  onImport: (accountId: string) => void;
  onAddExpense: (accountId: string) => void;
  onAccountDragEnd: (event: DragEndEvent) => void;
  onCreditCardDragEnd: (event: DragEndEvent) => void;
  formatCurrency: (value: number) => string;
  creditCardRefreshKey: number;
  // Agenda
  onRefresh: () => void;
  onViewTransaction: (alert: DueAlert) => void;
  // Gating
  importLocked?: boolean;
  creditCardLocked?: boolean;
  allAccountsLocked?: boolean;
  // Unused but passed via spread
  onNewTransaction?: () => void;
  onImportStatement?: () => void;
}

export function DashboardMobileTabs(props: DashboardMobileTabsProps) {
  return (
    <div className="md:hidden">
      <Tabs defaultValue="resumo" className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="resumo">Resumo</TabsTrigger>
          <TabsTrigger value="contas">Contas</TabsTrigger>
          <TabsTrigger value="agenda">Agenda</TabsTrigger>
        </TabsList>
        <TabsContent value="resumo" className="mt-4">
          <DashboardOverviewSection
            monthlyData={props.monthlyData}
            categoryData={props.categoryData}
            monthlyComparison={props.monthlyComparison}
            isLoading={props.analyticsLoading}
            compact
          />
        </TabsContent>
        <TabsContent value="contas" className="mt-4">
          <DashboardAccountsSection
            bankAccounts={props.bankAccounts}
            creditCards={props.creditCards}
            onAddAccount={props.onAddAccount}
            onAddCreditCard={props.onAddCreditCard}
            onEditAccount={props.onEditAccount}
            onAddTransaction={props.onAddTransaction}
            onViewInvoice={props.onViewInvoice}
            onImport={props.onImport}
            onAddExpense={props.onAddExpense}
            onAccountDragEnd={props.onAccountDragEnd}
            onCreditCardDragEnd={props.onCreditCardDragEnd}
            formatCurrency={props.formatCurrency}
            creditCardRefreshKey={props.creditCardRefreshKey}
            creditCardLocked={props.creditCardLocked}
            allAccountsLocked={props.allAccountsLocked}
          />
        </TabsContent>
        <TabsContent value="agenda" className="mt-4">
          <DashboardAgendaSection
            onRefresh={props.onRefresh}
            onViewTransaction={props.onViewTransaction}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
